/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SimulationStatusStatistics
 */
export interface SimulationStatusStatistics {
  /**
   *
   */
  name: string;
  /**
   *
   */
  total: number;
}

/**
 * Check if a given object implements the SimulationStatusStatistics interface.
 */
export function instanceOfSimulationStatusStatistics(
  value: object
): value is SimulationStatusStatistics {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("total" in value) || value["total"] === undefined) return false;
  return true;
}

export function SimulationStatusStatisticsFromJSON(json: any): SimulationStatusStatistics {
  return SimulationStatusStatisticsFromJSONTyped(json, false);
}

export function SimulationStatusStatisticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationStatusStatistics {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    total: json["total"],
  };
}

export function SimulationStatusStatisticsToJSON(json: any): SimulationStatusStatistics {
  return SimulationStatusStatisticsToJSONTyped(json, false);
}

export function SimulationStatusStatisticsToJSONTyped(
  value?: SimulationStatusStatistics | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    total: value["total"],
  };
}
